import React, { useState, useEffect } from "react";
import styled from "styled-components";
import alarmSvg from "../../assets/images/alarm.svg";
import userAvi from "../../assets/images/dummyAvi.svg";
import cloud from "../../assets/icons/cloud.svg";
import { RxCaretDown } from "react-icons/rx";
import ReusableTable from "../../reusables/ReusableTable";
import Filter from "./Filter";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calendar from "../../assets/icons/calendar.svg";
import filter from "../../assets/icons/filter.svg";
import search from "../../assets/icons/search.svg";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// imort dateFilter

const History = () => {
  const [init, setInit] = useState(1);
  const [page, setPage] = useState(1);
  const [txnData, setTxnData] = useState();
  const [limit, setLimit] = useState(10);
  const [mydata, setMyData] = useState();
  const [postsPerPage, setPostsPerOage] = useState(10);
  const [csvLimit, setCsvLimit] = useState("");
  const [csvInfo, setCsvInfo] = useState();
  const [recentTxnData, setRecentTxnData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const [endNumber, setEndNumber] = useState(indexOfLastPost);
  const [startCount, setStartCount] = useState(currentPage);
  const [endCount, setEndCount] = useState(currentPage * 10);
  const [startPoint, setStartPoint] = useState(0);
  const [endPoint, setEndPoint] = useState(5);
  const [isLastPage, setIsLastPage] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [date1Type, setDate1Type] = useState("text");
  const [date2Type, setDate2Type] = useState("text");

  let num = 1;

  const clientId = JSON.parse(sessionStorage.getItem("clientId"));
  const token = JSON.parse(sessionStorage.getItem("token"));

  //Table column goes in here. This is to be passed as props/////////////////////////////
  const columns = [
    { field: "no", header: "S/N" },
    { field: "amount", header: "AMOUNT" },
    { field: "date", header: "DATE" },
    { field: "status", header: "STATUS" },
  ];

  //APIs section starts here ////////////////////////////////////////////////////////////
  const getTransactions = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}transactions/${clientId}?page=${currentPage}&startDate=${startDate}&endDate=${endDate}&limit=${postsPerPage}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      // console.log(data);
      setTxnData(data);
      setLoading(false);
      setCsvLimit(data?.total);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  //APIs section ends here ////////////////////////////////////////////////////////////

  //APIs section starts here ////////////////////////////////////////////////////////////
  const getAllTransactions = async () => {
    try {
      // setLoading(txrue);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}transactions/${clientId}?page=1&startDate=${startDate}&endDate=${endDate}&limit=${csvLimit}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      // console.log(data);
      setCsvInfo(data?.data);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };
  //APIs section ends here ////////////////////////////////////////////////////////////

  useEffect(() => {
    if (csvLimit) {
      getAllTransactions();
    }
  }, [csvLimit]);

  let myData = txnData?.data;
  const dataLength = txnData?.total;

  const endPage = Math.ceil(dataLength / postsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(dataLength / postsPerPage); i++) {
    pageNumbers.push(i);
  }
  const myPageNumbers = pageNumbers.slice(startPoint, endPoint);

  const prevPageHandler = async () => {
    if (currentPage === 1) {
      return;
    } else if (currentPage === endPage) {
      setCurrentPage(currentPage - 1);
      setStartCount(startCount - Number(postsPerPage));
      setEndCount(endCount - Number(txnData?.data?.length));
      setInit(init - Number(limit));
    } else {
      setCurrentPage(currentPage - 1);
      setStartCount(startCount - Number(postsPerPage));
      setEndCount(endCount - limit);
      setInit(init - Number(limit));
    }
    if (currentPage <= startPoint + 1) {
      setStartPoint(startPoint - 5);
      setEndPoint(endPoint - 5);
    }
  };

  const nextPageHandler = async () => {
    if (currentPage >= endPage) {
      setIsLastPage(true);
      setEndCount(dataLength);
      return;
    } else {
      setCurrentPage(currentPage + 1);
      setStartCount(startCount + Number(postsPerPage));
      setEndCount(startCount + limit + limit - 1);
      setInit(init + Number(limit));
    }
    if (currentPage >= endPoint) {
      setEndPoint(endPoint + 5);
      setStartPoint(startPoint + 5);
    }
  };

  useEffect(() => {
    if (currentPage === endPage) {
      setEndCount(dataLength);
    } else {
      return;
    }
  }, [currentPage]);

  useEffect(() => {
    getTransactions();
    if (txnData && dataLength < postsPerPage) {
      setEndCount(dataLength);
    }
  }, [clientId, currentPage, postsPerPage]);

  const csvExportHandler = async () => {
    const data = csvInfo || [];

    const csvTableHead = ["S/N", "Amount", "Date", "Status"];

    const formattedData = data.map((item, index) => [
      index + 1,
      item.amount,
      item.createdAt,
      item.status,
    ]);

    const csvRows = [
      csvTableHead.join(","), // header row
      ...formattedData.map((row) => row.join(",")), // data rows
    ];

    const csvContent = csvRows.join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" }); // correct MIME type
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.download = "transactions.csv";
    a.href = url;
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  // console.log(csvInfo);

  const filterByDateHandler = () => {
    getTransactions();
    // getAllTransactions
  };

  const name = JSON.parse(sessionStorage?.getItem("name"));

  return (
    <Container>
      {" "}
      <div className="head">
        <div className="head_content">
          <img src={alarmSvg} alt="" />
          <div className="userProfileWrapper">
            <img src={userAvi} alt="" />
            <div className="userInfo">
              <p style={{ fontWeight: "bold" }}>{name}</p>
              <p style={{ fontSize: "11px", fontWeight: "bold" }}>User</p>
            </div>
            <RxCaretDown size={17} style={{ color: "#fff" }} />
          </div>
        </div>
      </div>
      <div className="contentWrapper">
        <div className="table-head">
          <p className="recentCustomers">Deposit History</p>
          <div className="filterSection">
            <FilterContainer>
              <DatePickers>
                <Range>
                  <input
                    type={date1Type}
                    value={date1Type === "text" ? "Start Date" : null}
                    onClick={() => {
                      setDate1Type("date");
                    }}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                    }}
                    min="2022-01-01"
                    max="2023-12-31"
                  />
                </Range>
              </DatePickers>
              <DatePickers>
                <Range>
                  <input
                    type={date2Type}
                    value={date2Type === "text" ? "End Date" : null}
                    onClick={() => {
                      setDate2Type("date");
                    }}
                    onChange={(e) => {
                      setEndDate(e.target.value);
                    }}
                    min="2022-01-01"
                    max="2023-12-31"
                  />
                </Range>
              </DatePickers>
              <Range
                style={{ width: "35px", cursor: "pointer" }}
                onClick={filterByDateHandler}
              >
                <img src={filter} alt="" />
              </Range>
              <SearchWrapper>
                <img src={search} alt="" />
                <input type="text" placeholder="Search" />
                <p style={{ cursor: "pointer" }}>Go</p>
              </SearchWrapper>
            </FilterContainer>
            <MobileContainer>
              <div className="dateInputsWrapper">
                <div className="dateInputs">
                  <Range>
                    <input
                      type={date1Type}
                      value={date1Type === "text" ? "Start Date" : null}
                      onClick={() => {
                        setDate1Type("date");
                      }}
                      onChange={(e) => {
                        setStartDate(e.target.value);
                      }}
                      min="2022-01-01"
                      max="2023-12-31"
                    />
                  </Range>
                  <Range>
                    <input
                      type={date2Type}
                      value={date2Type === "text" ? "End Date" : null}
                      onClick={() => {
                        setDate2Type("date");
                      }}
                      onChange={(e) => {
                        setEndDate(e.target.value);
                      }}
                      min="2022-01-01"
                      max="2023-12-31"
                    />
                  </Range>
                </div>

                <Range
                  style={{ width: "35px", cursor: "pointer" }}
                  onClick={filterByDateHandler}
                >
                  <img src={filter} alt="" />
                </Range>
              </div>
              <div className="mobileSearch">
                <img src={search} alt="" />
                <input type="text" placeholder="Search" />
                <p style={{ cursor: "pointer" }}>Go</p>
              </div>
            </MobileContainer>
            <button className="downloadBtn" onClick={csvExportHandler}>
              <img src={cloud} alt="" /> Download
            </button>
          </div>
        </div>
        {loading ? (
          <div style={{ padding: "0 30px" }}>
            <Skeleton height={500} />
          </div>
        ) : (
          <>
            <TableWrapper>
              <ReusableTable
                type="deposit-history"
                columns={columns}
                init={init}
                data={txnData?.data}
              />
            </TableWrapper>
            <PaginationWrapper>
              <h5>
                Showing {startCount} to {endCount} of {dataLength} Entries
              </h5>

              <div className="xPagination">
                <div className="perPage">
                  <p>Per page:</p>
                  <select
                    name="perPage"
                    id="perPage"
                    onChange={(e) => {
                      if (currentPage === 1) {
                        setPostsPerOage(e.target.value);
                        setEndCount(e.target.value);
                        setLimit(Number(e.target.value));
                      } else {
                        setCurrentPage(1);
                        setInit(1);
                        setStartCount(1);
                        setLimit(Number(e.target.value));
                        setPostsPerOage(e.target.value);
                        setEndCount(e.target.value);
                      }
                    }}
                    value={limit}
                  >
                    {[10, 20, 50].map((opt, idx) => {
                      return (
                        <option value={opt} key={idx}>
                          {opt}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <PaginationBtnWrapper>
                  <button onClick={prevPageHandler}>Previous</button>
                  {myPageNumbers.map((number) => (
                    <div key={number} className="numbers">
                      <p
                        href="#"
                        className="paginationNumbers"
                        style={{
                          background: currentPage === number ? "#28D1FF" : "",
                          color: currentPage === number ? "#fff" : "",
                          cursor: "pointer",
                        }}
                        key={number}
                        onClick={() => {
                          setCurrentPage(number);
                          setInit(number * postsPerPage - postsPerPage + 1);
                          setStartCount(
                            number * postsPerPage - postsPerPage + 1
                          );
                          setEndCount(number * postsPerPage);
                        }}
                      >
                        {number}
                      </p>
                    </div>
                  ))}
                  <button onClick={nextPageHandler}>Next</button>
                </PaginationBtnWrapper>
              </div>
            </PaginationWrapper>
          </>
        )}
      </div>
    </Container>
  );
};

export default History;

const Container = styled.div`
  padding: 30px;
  position: absolute;
  top: 0;
  width: calc(100% - 16%);
  max-width: calc(100% - 16%);
  @media only screen and (max-width: 1147px) {
    width: calc(100%);
    margin-left: 0;
    max-width: calc(100%);
  }
  @media only screen and (max-width: 450px) {
    padding: 0;
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .head_content {
      display: flex;
      width: 300px;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;

      @media only screen and (max-width: 450px) {
        width: 150px;
      }
      img {
        width: 35px;
        @media only screen and (max-width: 450px) {
          width: 20px;
        }
      }
      .userProfileWrapper {
        width: 200px;
        border-left: 1px solid #eeebeb;
        padding-left: 40px;
        display: flex;
        align-items: center;
        gap: 15px;

        @media only screen and (max-width: 450px) {
          width: 100px;
          padding-left: 0;
          margin-top: 20px;
          border-left: 0 solid #eeebeb;
          /* flex-direction: column; */
        }
        .userInfo {
          display: flex;
          flex-direction: column;
          gap: 8px;
          color: #fff;
          /* align-items: center; */

          p {
            @media only screen and (max-width: 450px) {
              font-size: 11px;
            }
          }
        }
        img {
          @media only screen and (max-width: 450px) {
            width: 40px;
          }
        }

        svg {
          @media only screen and (max-width: 450px) {
            display: none;
          }
        }
      }
    }
  }

  .contentWrapper {
    background-color: #fff;
    padding: 10px 0 80px;
    border-radius: 20px;
    margin-top: 50px;

    .firstContentHead {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media only screen and (max-width: 450px) {
        display: unset;
      }
      .pageName {
        font-size: 30px;
      }
      .filterWrapper {
        display: flex;
        align-items: center;
        gap: 15px;

        @media only screen and (max-width: 450px) {
          align-items: flex-start;
          justify-content: space-between;
          padding: 30px;
        }

        select {
          border: 1px solid #00000047;
          border-radius: 5px;
          padding: 5px;
        }
      }
    }

    .accountInfoWrapper {
      display: flex;
      gap: 12px;
      margin-top: 10px;
      flex-wrap: wrap;
      padding: 20px;
    }

    .table-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 5px;
      padding-right: 10px;
      @media only screen and (max-width: 987px) {
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 20px;
      }
      .filterSection {
        display: flex;
        align-items: center;
        gap: 10px;
        @media only screen and (max-width: 450px) {
          align-items: flex-start;
          justify-content: space-between;
          padding: 30px;
        }

        .downloadBtn {
          display: flex;
          align-items: center;
          height: 40px;
          width: 130px;
          background-color: #28d1ff;
          justify-content: center;
          gap: 8px;
          color: #fff;
          border: none;
          outline: none;
          font-weight: 500;
          border-radius: 4px;
          cursor: pointer;

          @media only screen and (max-width: 450px) {
            /* display: none; */
            width: 40px;
            font-size: 0;
          }

          img {
            width: 20px;
            margin-bottom: 2px;
            @media only screen and (max-width: 450px) {
              /* display: none; */
              margin-bottom: 0;
              margin-left: 4px;
            }
          }
        }
      }
      .recentCustomers {
        /* margin-top: 20px; */
        font-size: 20px;
        padding: 20px;

        @media only screen and (max-width: 987px) {
          display: none;
        }
        em {
          font-size: 25px;
        }
      }
    }
  }
`;
const TableWrapper = styled.div`
  /* margin: 20px 0; */
`;
export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  padding: 0 20px;
  h5 {
    font-weight: 500;
    @media only screen and (max-width: 450px) {
      display: none;
    }
  }
  .xPagination {
    display: flex;
    align-items: center;
    gap: 20px;

    .perPage {
      display: flex;
      align-items: center;
      gap: 5px;

      p {
        font-size: 13px;
        @media only screen and (max-width: 450px) {
          font-size: 9px;
        }
      }

      select {
        height: 30px;
        padding: 0 10px;
        cursor: pointer;
        border-radius: 8px;
        border: 1px solid #d2d2d2;
        color: #4d4c4c;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
      }
    }
  }
`;
export const PaginationBtnWrapper = styled.div`
  border: 1px solid #d2d2d2;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 31px;

  button:not(.numbers a) {
    text-decoration: none;
    color: black;
    margin: 0 10px;
    font-size: 11px;
    font-weight: 600;
    font-family: "Karla", sans-serif;
    border: none;
    background: none;
    cursor: pointer;
    height: 100%;
  }

  .numbers {
    margin-bottom: 0px;

    p {
      cursor: pointer;
      color: black;
      text-decoration: none;
      border: 0.5px solid #d2d2d2;
      padding: 8px 12px;
      font-family: "Karla", sans-serif;
      font-size: 11px;
      font-weight: 600;

      &:hover {
        background-color: #dff0f452;
      }
      @media only screen and (max-width: 450px) {
        font-size: 9px;
      }
    }
  }
`;
const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  @media only screen and (max-width: 450px) {
    display: none;
  }
`;

export const Range = styled.div`
  display: flex;
  border: 1px solid #28d1ff;
  background-color: #fff;
  width: 150px;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10px;
  border-radius: 6px;
  input {
    border: none;
    outline: none;
    width: 130px;
    height: 37px;
    cursor: pointer;
    font-family: "Karla", sans-serif;
  }
  .myInput {
    height: 30px;
    width: 120px;
    border: none;
    outline: none;
    cursor: pointer;
    background: transparent;
  }
  img {
    width: 15px;
  }
  select {
    border: none;
    width: 50px;
    &:active,
    &:focus {
      outline: none;
    }
  }
`;

const DatePickers = styled.div`
  p {
    font-size: 11px;
    margin-bottom: 2px;
    font-weight: 500;
    margin-left: 1px;
  }
`;
const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #28d1ff;
  height: 40px;
  border-radius: 6px;
  padding: 0 2px 0 10px;

  input {
    width: 220px;
    border: none;
    outline: none;
    height: 90%;
    margin-left: 9px;
  }
  p {
    background-color: #28d1ff;
    height: 35px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 5px;
    font-size: 14px;
  }
`;

const MobileContainer = styled.div`
  display: none;
  @media only screen and (max-width: 450px) {
    display: block;
    position: relative;
    .dateInputsWrapper {
      display: flex;
      gap: 20px;

      .dateInputs {
        /* margin-left: 10px; */

        div {
          margin-bottom: 10px;
        }
      }
    }

    .mobileSearch {
      margin-top: 10px;
      /* margin-left: 10px; */
      display: flex;
      align-items: center;
      border: 1px solid #28d1ff;
      height: 40px;
      border-radius: 6px;
      /* width: 90%; */
      padding: 0 2px 0 10px;
      /* position: absolute; */
      input {
        width: 220px;
        border: none;
        outline: none;
        height: 90%;
        margin-left: 9px;
      }
      p {
        background-color: #28d1ff;
        height: 35px;
        width: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border-radius: 5px;
        font-size: 14px;
      }
    }
  }
`;
